import { db } from '../firebase'

const register = function (uid, datas) {
  return db.collection('users')
    .doc(uid)
    .collection('notes')
    .add(datas)
    .then((res) => {
      return true
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

const update = function (uid, datas, id) {
  return db.collection('users')
    .doc(uid)
    .collection('notes')
    .doc(id)
    .update(datas)
    .then((res) => {
      return true
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

const list = function (uid) {
  return db.collection('users')
    .doc(uid)
    .collection('notes')
    .orderBy('date', 'desc')
    .get()
    .then((res) => {
      return res
    })
    .catch((err) => {
      console.log(err)
      return false
    })
}

const remove = function (uid, id) {
  return db.collection('users')
    .doc(uid)
    .collection('notes')
    .doc(id)
    .delete()
}

export { register, list, remove, update }
